document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.video-hero--video');

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    const source = video.getAttribute('data-src');
                    if (source && !video.src) {
                        video.src = source;
                        video.load();
                    }
                    observer.unobserve(video);
                }
            });
        });

        videos.forEach(video => observer.observe(video));
    } else {
        videos.forEach(video => {
            const source = video.getAttribute('data-src');
            if (source) {
                video.src = source;
                video.load();
            }
        });
    }
});
